import { UrlQueryParamsInterface } from 'pf-frontend-common/src/helper/url/query-params.interface';

import { objectFilterFalsy } from 'common/helper/object/filter/falsy';
import { AgentSerpStoreStateParamsInterface } from 'common/module/agent-serp/store/state-params.interface';

// TODO-FE[later]: Refactor into transformers
export class AgentSerpQueryParamsAdapter {
  /**
   * Transforms UrlQueryParamsInterface into AgentSerpStoreStateParamsInterface
   */
  public toAgentSerpStoreStateParams(params: UrlQueryParamsInterface): AgentSerpStoreStateParamsInterface {
    return {
      'page[number]': parseInt(params.page, 10) || 1,
      'filter[nationality]': String(params.nationality || ''),
      'filter[language_ids]': params.languageIds,
      'filter[name]': params.text,
      'filter[id]': params.id,
      'filter[broker_id]': params.brokerId,
      'filter[location_id]': params.locationId,
      'filter[category_id]': params.categoryId,
      sort: params.orderBy,
    };
  }

  /**
   * Transforms to compact UrlQueryParamsInterface
   */
  public toCompact(params: UrlQueryParamsInterface): UrlQueryParamsInterface {
    return objectFilterFalsy(params);
  }

  /**
   * Transforms AgentSerpStoreStateParamsInterface into UrlQueryParamsInterface
   */
  public fromAgentSerpStoreStateParams(params: AgentSerpStoreStateParamsInterface): UrlQueryParamsInterface {
    return {
      page: params['page[number]'] || 1,
      nationality: params['filter[nationality]'] || '',
      language_ids: params['filter[language_ids]'] || '',
      text: params['filter[name]'] || '',
      id: params['filter[id]'] || '',
      broker_id: params['filter[broker_id]'] || '',
      location_id: params['filter[location_id]'] || '',
      category_id: params['filter[category_id]'] || '',
      order_by: params.sort || '',
    };
  }
}
